



































































































import { Vue, Component } from "vue-property-decorator";
import HIVEAlert from "@/components/common/alerts/HIVEAlert.vue";
import HIVETextField from "@/components/common/HIVETextField.vue";
import Organization from "@/classes/Organization";
import HeaderField from "@/classes/HeaderField";
import HeaderFieldConstant from "@/classes/helpers/HeaderFieldConstant";

@Component({
  components: {
    HIVEAlert,
    HIVETextField
  },
})
export default class SymetriReports extends Vue {

    private timeFrameByDays = [
    { text: "Last 30 days", value: 30 },
    { text: "Last 60 days", value: 60 },
    { text: "Last 90 days", value: 90 },
    { text: "Last 365 days", value: 365 },
  ];

      private toolHeaders: Array<HeaderField> = [
    new HeaderField(HeaderFieldConstant.Name, "name")
  ];

      private productHeaders: Array<HeaderField> = [
    new HeaderField(HeaderFieldConstant.Name, "name")
  ];

    private orgHeaders: Array<HeaderField> = [
    new HeaderField(HeaderFieldConstant.Name, HeaderFieldConstant.orgName)
  ];

    private selectedProductIdsList: Array<string> = [];
    private selectedTimeByDays: number = this.timeFrameByDays[0].value;

    private selectedOrgId = ""
    private selectedProducts = []
    private selectedTools = []

    private orgSearch: string = "";
    private productSearch: string = "";
    private toolSearch: string = "";

      private get icon() {
    if (this.selectAllReportProducts) return "mdi-close-box";
    if (this.getSelectedProductIdsList.length > 0) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

    private get getProductTools() {
      return this.$store.getters["uicontrols/getProductTools"];
    }

    private get getSelectedOrgProducts() {
      return this.$store.getters["uicontrols/getSelectedOrgProducts"];
    }
    private set getSelectedOrgProducts(val) {
      return this.$store.commit("uicontrols/setSelectedOrgProducts", val);
    }

    private get getOrganizations() {
      return this.$store.getters["organizations/getOrganizations"];
    }
      private get getSelectedTimeByDays() {
        return this.selectedTimeByDays
    }
    private set getSelectedTimeByDays(val) {
        this.selectedTimeByDays = val
            this.$store.dispatch("uicontrols/getSessionsCountsAsync", 
            {  
              timeFrame: val
            });
    }

    public get getSelectedOrgId() { 
      return this.selectedOrgId
    }
    public set getSelectedOrgId(val) { 
      if(this.selectedOrgId === val){
        this.selectedOrgId = ""
      }
      else {
      this.selectedOrgId = val
      }
      this.getSelectedProducts = []
      this.getSelectedTools = []
      this.getSelectedOrgProducts = []
    }

    public get getSelectedProducts() { 
      return this.selectedProducts
    }
    public set getSelectedProducts(val) { 
      this.selectedProducts = val
    }

    public get getSelectedTools() { 
      return this.selectedTools
    }
    public set getSelectedTools(val) { 
      this.selectedTools = val
    }

    public get getTools() {
      let tools = this.deepCopy(this.$store.getters["uicontrols/getTools"]);
      if(this.getSelectedOrgId != "") {
      let productTools = this.deepCopy(this.getProductTools)
      let productList = this.deepCopy(this.getProductsList)
      
      productTools = productTools.filter(obj =>
        productList.some(product => product.id === obj.productId)
      );
      var toolIds = productTools.map(pt => pt.toolIds).flat()
      tools = tools.filter(obj => toolIds.includes(obj.id));
    }

    if(this.getSelectedProducts.length > 0) {
      let productTools = this.deepCopy(this.getProductTools)
      let productList = this.deepCopy(this.getSelectedProducts)
      
      productTools = productTools.filter(obj =>
        productList.some(product => product.id === obj.productId)
      );
      var toolIds = productTools.map(pt => pt.toolIds).flat()
      tools = tools.filter(obj => toolIds.includes(obj.id));
    }
    return tools
  }

    private get selectAllReportProducts() {
    return this.getProductsList.length === this.getSelectedProductIdsList.length;
  }

    public get getSelectedProductIdsList() {
    return this.selectedProductIdsList
  }
  public set getSelectedProductIdsList(val) {
    this.selectedProductIdsList = val
    // this.getConcurrencyLicenseUsageChart()
  }

  private get getProductsList() {
    let products = this.deepCopy(this.$store.getters["uicontrols/getProducts"]);
    if(this.getSelectedOrgId !== "") {
    products = products.filter(obj => this.getSelectedOrgProducts.includes(obj.id));
    }

    return products
  }
  
  private get getIsChartLoading() {
    return this.$store.getters["uicontrols/getIsGraphLoading"];
  }

    private get sessionCounts() {
    return this.$store.getters["uicontrols/getSessionCounts"];
  }

      private get getDistinctUserCounts() {
    return this.$store.getters["uicontrols/getDistinctUserCounts"];
  }

  private get getOrgRowClass(item) {
      return item.id === this.getSelectedOrgId ? 'selected-row' : '';
  }

  public get totalSessionCounts() {
    // const isLoading = this.getIsChartLoading;
    let title = 'Session Counts'
    let type = ''

    let records = this.deepCopy(this.sessionCounts);
    if(this.getSelectedOrgId !== "") {
      records = records.filter(r => r.organizationId === this.getSelectedOrgId)
    }
    if(this.getSelectedProducts.length > 0) {
      records = records.filter(r => this.getSelectedProducts.some(product => product.id === r.productId))
    }
    if(this.getSelectedTools.length > 0) {
      records = records.filter(r => this.getSelectedTools.some(tool => tool.id === r.toolId))
    }

    let chartData = []
    if(records.length > 0) {
      if(this.getSelectedProducts.length > 0 || this.getSelectedTools.length > 0) {
        var groupedRecords = this.sessionCountsTransformedByTools(records)
        groupedRecords.forEach(item => {
            let name = this.getTools.find(t => t.id === item.id).name
                      chartData.push({
                        id: item.id,
                        dataPointType: 'tool',
                        name: name,
                        y: item.sessionCount,
                  })
          })
        }
        else {
          var groupedRecords = this.sessionCountsTransformedByProducts(records)
          groupedRecords.forEach(item => {
            let name = this.getProductsList.find(p => p.id === item.id).name
                      chartData.push({
                        id: item.id,
                        dataPointType: 'product',
                        name: name,
                        y: item.sessionCount,
                  })
          })
        }
    }

    const chartOptions = {
      chart: {
        type: "column",
        events: {
          // load() {
          //   if (isLoading) {
          //     this.showLoading("Loading...");
          //   } else {
          //     this.hideLoading();
          //   }
          // },
          // render() {
          //   if (!isLoading) {
          //     this.hideLoading();
          //   }
          // },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: title,
        align: "left",
        style: {
          fontWeight: "bold",
          fontFamily: "sans-serif",
          fontSize: "14px",
          padding: "5px",
        },
      },
      xAxis: {
        type: "category",
        categories: [],
        labels: {
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif",
          },
        },
      },
      yAxis: {
        title: {
          text: "Session Count",
          style: {
            fontFamily: "sans-serif",
          },
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        pointFormat: "<b>Session Count:</b> {point.y}",
      },
      plotOptions: {
            series: {
                point: {
                    // events: {
                    //     click: (e) => {
                    //         this.dataPointClick(e)
                    //     }
                    // }
                },
            }
        },
      series: [
        {
          cursor: 'pointer',
          name: "Sessions",
          data: []
        },
      ],
    };

    chartOptions.xAxis.categories = chartData.map(r => r.name)
    chartOptions.series[0].data = chartData

    return chartOptions;
  }

  public get distinctUserCounts() {
    // const isLoading = this.getIsChartLoading;
    let title = 'Distinct User Counts'
    let type = ''

    let records = this.deepCopy(this.getDistinctUserCounts);
    if(this.getSelectedOrgId !== "") {
      records = records.filter(r => r.organizationId === this.getSelectedOrgId)
    }

    if(this.getSelectedProducts.length > 0) {
      let spids = this.getSelectedProducts.map(p => p.id)

      records = records.filter(r => {
        if(Object.keys(r.distinctUserCountsByProducts).some(key => spids.includes(key))) {
          return r
        }
      })
    }

    if(this.getSelectedTools.length > 0) {
      let stids = this.getSelectedTools.map(t => t.id)
      stids.forEach(stid =>
      records = records.filter(r => {
        if(Object.keys(r.distinctUserCountsByTools).some(key => stids.includes(key))) {
          return r
        }
      })
      )
    }

    let chartData = []
    let pids = this.getProductsList.map(p => p.id)
    let tids = this.getTools.map(t => t.id)
      if(this.getSelectedProducts.length > 0 || this.getSelectedTools.length > 0) {
            let flattenedCountKVPairs = records.map(r => r.distinctUserCountsByTools).flat()
            tids.forEach(tid => {
            let count = 0
            flattenedCountKVPairs.forEach(kv => {
              if(kv[tid] !== undefined) {
                count += kv[tid]
              }
            })

            if(count > 0 && tid) {
              if(this.getSelectedTools.length > 0) {
                let stids = this.getSelectedTools.map(t => t.id)
                if(stids.find(stid => stid === tid) === undefined) {
                  return
                }
            }
              let name = this.getTools.find(p => p.id === tid).name
                chartData.push({
                id: tid,
                dataPointType: 'tool',
                name: name,
                y: count,
              })
            }
          })

        chartData = chartData.sort((a, b) => b.y - a.y)
    }
    else {
        let flattenedCountKVPairs = records.map(r => r.distinctUserCountsByProducts).flat()
        pids.forEach(pid => {
            let count = 0
            flattenedCountKVPairs.forEach(kv => {
              if(kv[pid] !== undefined) {
                count += kv[pid]
              }
            })

            if(count > 0 && pid) {
              if(this.getSelectedProducts.length > 0) {
                let spids = this.getSelectedProducts.map(p => p.id)
                if(spids.find(spid => spid === pid) === undefined) {
                  return
                }
            }
            let name = this.getProductsList.find(p => p.id === pid).name
              chartData.push({
              id: pid,
              dataPointType: 'product',
              name: name,
              y: count,
            })
            }
          })

        chartData = chartData.sort((a, b) => b.y - a.y)
    }

    const chartOptions = {
      chart: {
        type: "column",
        events: {
          // load() {
          //   if (isLoading) {
          //     this.showLoading("Loading...");
          //   } else {
          //     this.hideLoading();
          //   }
          // },
          // render() {
          //   if (!isLoading) {
          //     this.hideLoading();
          //   }
          // },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: title,
        align: "left",
        style: {
          fontWeight: "bold",
          fontFamily: "sans-serif",
          fontSize: "14px",
          padding: "5px",
        },
      },
      xAxis: {
        type: "category",
        categories: [],
        labels: {
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif",
          },
        },
      },
      yAxis: {
        title: {
          text: "Distinct User Count",
          style: {
            fontFamily: "sans-serif",
          },
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        pointFormat: "<b>Distinct Users:</b> {point.y}",
      },
      plotOptions: {
            series: {
                point: {
                    // events: {
                    //     click: (e) => {
                    //         this.dataPointClick(e)
                    //     }
                    // }
                },
            }
        },
      series: [
        {
          cursor: 'pointer',
          name: "Sessions",
          data: []
        },
      ],
    };

    chartOptions.xAxis.categories = chartData.map(r => r.name)
    chartOptions.series[0].data = chartData

    return chartOptions;
  }

  private sessionCountsTransformedByProducts(records: any) {
    const grouped = records.reduce((acc, item) => {
    if (!acc[item.productId]) {
      acc[item.productId] = { id: item.productId, sessionCount: 0 };
    }
    acc[item.productId].sessionCount += item.sessionCount;
    return acc;
  }, {});

  return Object.values(grouped).sort((a, b) => b.sessionCount - a.sessionCount);
  }

  private sessionCountsTransformedByTools(records: any) {
    const grouped = records.reduce((acc, item) => {
    if (!acc[item.toolId]) {
      acc[item.toolId] = { id: item.toolId, sessionCount: 0 };
    }
    acc[item.toolId].sessionCount += item.sessionCount;
    return acc;
  }, {});

  return Object.values(grouped).sort((a, b) => b.sessionCount - a.sessionCount);
  }

    private selectOrgRow(val) {
      this.getSelectedOrgId = val.id
      if(this.getSelectedOrgId !== "") {
        this.$store.dispatch("uicontrols/getSelectedOrgProducts", this.getSelectedOrgId);
      }
    }

    private selectAllProducts() {
    if (this.selectAllReportProducts) {
      this.getSelectedProductIdsList = [];
    } else {
      this.getSelectedProductIdsList = this.getProductsList.slice().map(p => p.id);
    }
    // this.getConcurrencyLicenseUsageChart()
  }

    private clearSelections(clearProduct: boolean = true) {
    // if(clearProduct) { this.getProductPointSelected = null }
    // this.getToolPointSelected = null
    // this.getUserPointSelected = null
  }

  private deepCopy(item: any) {
    return JSON.parse(JSON.stringify(item))
  }

    private created() {
    this.$store.dispatch("organizations/getOrganizationsAsync");
    this.$store.dispatch("uicontrols/getProductsListAsync");
    this.$store.dispatch("uicontrols/getToolsListAsync");
    this.$store.dispatch("uicontrols/getSessionsCountsAsync");
    this.clearSelections()
  }
}
